import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import HeaderSection from "../../components/HeaderSection";
import ItemDetails from "../../components/itemDetails";
import PromotionalPopupDisplay from "../../components/PromotionalPopupDisplay";
import { useActivity } from "../../contexts/ActivityContext";
import { useAuth } from "../../contexts/AuthContext";
import { useLoading } from "../../contexts/LoadingContext";
import { MenuContext } from "../../contexts/MenuContext";
import { isImageUrl } from "../../utils/isImageUrl";
import CategoryListUser from "./CategoryListUser";
import ItemListUser from "./ItemListUser";
import MenuListUser from "./MenuListUser";

const MenuPage = () => {
  const theme = useTheme();
  const {
    menus,
    filteredItems,
    categories,
    activeMenu,
    selectedCategory,
    handleMenuClick,
    handleCategoryClick,
  } = useContext(MenuContext);
  const { themeBg } = useAuth();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const { startLoading, stopLoading } = useLoading();
  const { trackItem } = useActivity();
  const [contentHeight, setContentHeight] = useState(0); // Start with height 0 for initial grow effect

  const dimensions = {
    contentContainerWidth: 992,
    itemListBoxPadding: 16,
    upperContentHeight: 68,
  };
  const calculateDime = (screenSize = "md") => {
    const maxWidth = dimensions.contentContainerWidth + "px";
    let height = "";
    if (screenSize === "md") {
      height = `${dimensions.upperContentHeight}svh`;
    } else if (screenSize === "xs") {
      height = `60svh`;
    }
    return { maxWidth, height };
  };

  const isTablet = useMediaQuery("(max-height: 720px)");
  const isMobile = useMediaQuery(theme.breakpoints.up("md"));

  if (isMobile) {
    dimensions.upperContentHeight = 58;
  }
  if (isTablet){
    dimensions.upperContentHeight = 66;
  }
  useEffect(() => {
    // Increase height gradually after mount
    setTimeout(() => {
      setContentHeight({
        xs: showOverlay ? 0 : calculateDime("xs").height,
        md: showOverlay ? 0 : calculateDime("md").height,
      });
    }, 300); // Adjust delay for smooth initial growth
  }, [showOverlay]);

  const handleOpenOverlay = async (item) => {
    // startLoading();
    try {
      // const { data } = await getItemById(item.id);
      trackItem(item.id);
      setSelectedItem(item);
      setShowOverlay(true);
    } catch (error) {
      console.error(error);
    }
    // finally {
    //   stopLoading();
    // }
  };

  const handleCloseOverlay = () => {
    setShowOverlay(false);
    setTimeout(() => {
      setSelectedItem(null);
    }, 1000);
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100svh",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: theme.palette.secondary.main,
        backgroundImage: isImageUrl(themeBg) ? `url(${themeBg})` : "none",
      }}
    >
      <PromotionalPopupDisplay onItemClick={handleOpenOverlay} />
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          position: "fixed",
          top: 0,
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          height: contentHeight, // Use dynamic height
          width: "100vw",
          alignItems: "center",
          p: 0,
          m: 0,
          px: { xs: "16px", md: 0 },
          transition: "height 0.5s ease", // Smooth transition for initial and overlay-triggered changes
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            maxWidth: {
              xs: "92%",
              md: calculateDime("md").maxWidth,
            },
            height: "100%",
            width: "100%",
          }}
        >
          <HeaderSection />
          <MenuListUser
            menus={menus}
            activeMenu={activeMenu}
            handleMenuClick={handleMenuClick}
          />
          <CategoryListUser
            categories={categories}
            selectedCategory={selectedCategory}
            handleCategoryClick={handleCategoryClick}
          />
        </Box>
      </Box>
      <ItemDetails
        height={dimensions.upperContentHeight}
        selectedItem={selectedItem}
        handleCloseOverlay={handleCloseOverlay}
      />
      <ItemListUser
        items={filteredItems}
        selectedCategory={selectedCategory}
        dimensions={dimensions}
        handleOpenOverlay={handleOpenOverlay}
        handleCloseOverlay={handleCloseOverlay}
        selectedItem={selectedItem}
      />
    </Box>
  );
};

export default MenuPage;
